export default __webpack_public_path__ + "static/media/logo_petit_m.a4777b8b.png";